import { API_CALL } from './actionConstants'
import { FETCH_POPULAR_FILTERS } from './apiActionConstants'
import * as SearchService from 'api/search'

export function fetchPopularFilters() {
  return (dispatch, getState) => {
    const state = getState() as App.State

    dispatch({
      type: API_CALL,
      api: FETCH_POPULAR_FILTERS,
      request: () => SearchService.getPopularFilters(state.geo.currentRegionCode),
    })
  }
}
